module.exports = __webpack_public_path__ + "img/dividendContainer1Model.7e34a940.png";